export default __webpack_public_path__ + "static/O0003-b4b8dc9e95533c67f8bad4d604db38a5.png";